import { useQuery } from "@apollo/client";
import { MY_HR_GET_MARITAL_STATUSES } from "my-hr/graphql";

export const useMyHrMaritalStatuses = () => {
  const { data, loading, error } = useQuery(MY_HR_GET_MARITAL_STATUSES, {
    fetchPolicy: "cache-and-network",
  });

  const result = data?.maritalStatuses || [];

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyHrMaritalStatuses;
